var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1ce8ec5c2a7f1af6b1835a19a2f600c1e850643d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["mypage@inditidual"]={id:"1ce8ec5c2a7f1af6b1835a19a2f600c1e850643d"};
      